export default {
	namespaced: true,

	state: {
		ForUser: {
			default: 'For User'
		},
		ForAdmin: {
			default: 'For Admin'
		},
		// index
		Welcome: {
			default: 'Welcome'
		},
		IncentivePointProgram: {
			default: 'Incentive Point Program'
		},
		StartTutorial: {
			default: "Start Tutorial"
		},
		StartNews: {
			default: "Start News"
		},
		// tutorial
		Tutorial: {
			default: 'Tutorial'
		},
		HowToInstall: {
			default: 'How To Install'
		},
		HowToInstallText: {
			default: 'You can install this website to your mobile phone and desktop.'
		},
		HowToLogin: {
			default: 'How To Lgoin'
		},
		HowToLoginText: {
			default: 'You can login by your username / email / phone.<br>If you are not informed about your user account please contact us.'
		},
		HowToAllowNotification: {
			default: 'How To Allow Notification'
		},
		HowToAllowNotificationText: {
			default: 'You can receive push notification on your mobile phone and desktop.'
		},
		HowToResetPassword: {
			default: 'How To Reset Password'
		},
		HowToResetPasswordText: {
			default: 'You can reset password from Profile page.'
		},
		OpenTutorial: {
			default: 'Open Tutorial'
		},
		// tutorialHowToInstall
		Open: {
			default: 'Open'
		},
		OpenWebSite: {
			default: 'Open Web Site'
		},
		OpenWebSiteText: {
			default: 'Please open web site from URL link.'
		},
		ClickAdd: {
			default: 'Click Add'
		},
		ClickAddOnInfo: {
			default: 'Click Add On Info'
		},
		ClickAddOnInfoText: {
			default: {
				web: 'Please click <b>Install</b> on your web browser.',
				mobile: 'Please click <b>Add to Home screen</b> to install mobile app.'
			}
		},
		ClickAddOnPopup: {
			default: 'Click Add On Popup'
		},
		ClickAddOnPopupText: {
			default: 'Please click <b>Add to Home screen</b> to install mobile app.'
		},
		Added: {
			default: 'Added'
		},
		AddedToHomeScreen: {
			default: 'Added To Home Screen'
		},
		AddedToHomeScreenText: {
			default: 'The mobile app is installed on your Home Screen'
		},
		OpenMobileApp: {
			default: 'Open Mobile App'
		},
		OpenMobileAppText: {
			default: 'Please tap the app icon installed on your Home Screen'
		},
		// tutorialHowToLogin
		ClickLogin: {
			default: 'Click Login'
		},
		ClickLoginText: {
			default: 'Please click login button on the right top.'
		},
		LoginPage: {
			default: 'Login Page'
		},
		LoginPageText: {
			default: 'Open login page.'
		},
		Select: {
			default: 'Select'
		},
		SelectLoginOption: {
			default: 'Select Login Option'
		},
		SelectLoginOptionText: {
			default: 'Please select your login option.'
		},
		Enter: {
			default: 'Enter'
		},
		EnterUsernameAndPassword: {
			default: 'Enter Username And Password'
		},
		EnterUsernameAndPasswordText: {
			default: 'If you choose <b>Username</b> as login option, please enter your username and password.'
		},
		// tutorialHowToAllowNotification
		ClickAllow: {
			default: 'Click Allow'
		},
		ClickAllowOnPopUp: {
			default: 'Click Allow On Pop Up.'
		},
		ClickAllowOnPopUpText: {
			default: 'Please click Allow button on the pop up window.'
		},
		ClickAllowOnNotification: {
			default: 'Click Allow On Notification.'
		},
		ClickAllowOnNotificationText: {
			default: 'Please click Allow button on the notification window.'
		},
		Show: {
			default: 'Show'
		},
		ShowNotification: {
			default: 'Show Notification'
		},
		ShowNotificationText: {
			default: 'Push notification will be shown'
		},
		// tutorialHowToResetPassword
		OpenProfile: {
			default: 'Open Profile'
		},
		OpenProfilePage: {
			default: 'Open Profile Page'
		},
		OpenProfilePageText: {
			default: 'Open Profile page from the menu at the right top.'
		},
		ClickReset: {
			default: 'Click Reset.'
		},
		ClickResetText: {
			default: 'Please click reset button.'
		},
		EnterPassword: {
			default: 'Enter Password'
		},
		EnterNewPasswordAndConfirmPassword: {
			default: 'Enter New Password And Confirm Password'
		},
		EnterNewPasswordAndConfirmPasswordText: {
			default: 'Please enter your new password'
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
